import { Pause, Play, VolumeX } from "lucide-react";

const promoUrl = "https://customer-assets-jt897jd0.emergentagent.net/job_innovation-ecosystem-4/artifacts/2rlrf2f8_GAMEDAY_Genesis_Cinematic_Promo.mp4";
const posterUrl = "https://customer-assets-jt897jd0.emergentagent.net/job_innovation-ecosystem-4/artifacts/lhmk1xbq_ChatGPT%20Image%20Jul%2021%2C%202026%2C%2011_31_35%20AM.png";

function PlaybackControl({ playing, onToggle }) {
  return (
    <div className="vision-controls" data-testid="vision-video-controls">
      <span><VolumeX size={14} /> Muted autoplay</span>
      <button className="video-control-button" type="button" onClick={onToggle} data-testid="vision-playback-button" aria-label={playing ? "Pause GAMEDAY Genesis film" : "Play GAMEDAY Genesis film"}>
        {playing ? <Pause size={16} /> : <Play size={16} />}
        {playing ? "Pause film" : "Play film"}
      </button>
    </div>
  );
}

export default function VisionHero({ videoRef, playing, onPlay, onPause, onToggle }) {
  return (
    <section className="vision-hero" data-testid="vision-promo-section">
      <video ref={videoRef} autoPlay loop muted playsInline preload="metadata" poster={posterUrl} aria-label="GAMEDAY Genesis cinematic promotional film" data-testid="gameday-genesis-video" onPlay={onPlay} onPause={onPause}>
        <source src={promoUrl} type="video/mp4" />
      </video>
      <div className="vision-video-shade" />
      <div className="vision-hero-content">
        <span className="eyebrow">GAMEDAY Genesis / Film 01</span>
        <h1>THE VISION<br />IN <em>MOTION.</em></h1>
        <p>A cinematic introduction to GAMEDAY’s proposed future of performance, readiness, innovation, and human potential.</p>
      </div>
      <PlaybackControl playing={playing} onToggle={onToggle} />
    </section>
  );
}